export function formatToLATime(time: string) {
  const iso = time.endsWith("Z") ? time : time + "Z";
  const utc = new Date(iso); // any UTC Date
  const s = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/Los_Angeles",
    dateStyle: "medium",
    timeStyle: "short",
  }).format(utc);
  const a = s.replace(", ", "/").replace(", ", "/");
  return a;
}
